import React from 'react'
import styled from '@emotion/styled'
import { useInView } from 'react-cool-inview'

import getVar from '../utils/getVar'


const ObserverHelperBottom = styled('div')`
  position: absolute;
  //bottom: 2vh;
  bottom: var(--real2vh);
  //bottom: ${props => props.real2vh};

  height: 200px;
  width: 11px;
  pointer-events: none;
  z-index: 500;
  //background-color: red;
`

const ObserverBottom = ({title, id, setCurrentProject, setFieldNotes, fieldNotes, isLast, setHideStatusContainer}) => {
  const real2vh  = getVar('--real2vh')

  let alreadyInView = false;
  const threshold = [0, 0.2, 0.4, 0.6, 0.8, 1];

  const { observe, inView, scrollDirection, entry } = useInView(
    {
      threshold,
      trackVisibility: true,
      delay: 100,

      onChange: ({ entry, scrollDirection }) => {
        const { intersectionRatio } = entry;

        if (intersectionRatio >= Math.min(...threshold) && !alreadyInView) {

          if(scrollDirection.vertical === 'down') {
            title ? setCurrentProject(title) : setCurrentProject(null)
          }

          if(scrollDirection.vertical === 'down') {
            fieldNotes ? setFieldNotes(fieldNotes) : setFieldNotes(null)
          }

          alreadyInView = true;
        } else if (intersectionRatio <= Math.max(...threshold) && alreadyInView) {
          //console.log("LOG ===> onLeave");
          alreadyInView = false;
        }
      },

      /*
      onChange: ({ inView, scrollDirection, entry, observe, unobserve }) => {
        // Triggered whenever the target meets a threshold, e.g. [0.25, 0.5, ...]
        console.log(scrollDirection)
      },*/

      onEnter: ({ scrollDirection }) => {
        if (typeof window !== 'undefined') {
          // window.history.replaceState({}, '', id);
          window.history.replaceState(null,  null, `${window.location.origin}/${id}`);
        }

        if(scrollDirection.vertical === 'down' && isLast) {
          setHideStatusContainer(false)
        }

        // console.log('bottom entering')

        // Does it work without direction check? (since direction check is buggy)
        // title ? setCurrentProject(title) : setCurrentProject(null)
        // fieldNotes ? setFieldNotes(fieldNotes) : setFieldNotes(null)

        // scrollDirection.vertical === 'down' ? setCurrentProject(title) : null



        /*
        if(scrollDirection.vertical === 'down') {
          title ? setCurrentProject(title) : setCurrentProject(null)
        }

        if(scrollDirection.vertical === 'down') {
          fieldNotes ? setFieldNotes(fieldNotes) : setFieldNotes(null)
        }
        */
      },

      onLeave: ({ scrollDirection }) => {
        if(scrollDirection.vertical === 'up' && isLast) {
          window.history.replaceState({}, '', '/')

          //setCurrentProject(null)
          //setFieldNotes(null)
          setHideStatusContainer(true)
        }
      }
    }
  );


  return (
    <ObserverHelperBottom 
      ref={observe} 
      real2vh={real2vh}
    />
  )
}

export default ObserverBottom